import { Box, Typography, Image, Flex, Divider } from "@jewlr/storybook/core"

import { TitleWithLine } from "../jewlr/components"

import { whatsCoveredData } from "./data"

const WhatsCovered = () => (
  <Box>
    <TitleWithLine>What&apos;s Covered</TitleWithLine>
    <Flex
      flexDirection={{ _: "column", tablet: "row" }}
      flexWrap={{ tablet: "wrap" }}
    >
      {whatsCoveredData().map((item, index) => (
        <Box
          alignItems="center"
          display={{ _: "block", tablet: "flex" }}
          flex={{ _: 1, tablet: "0 0 50%" }}
          key={`${item.title}-${index}`}
          mb={{ _: 5, tablet: 3 }}
        >
          <Box flex="0 0 auto" textAlign={{ _: "center", tablet: "right" }}>
            <Image
              alt={item.title}
              height={{ _: "75px", tablet: "85px" }}
              mb={{ _: 1, tablet: 0 }}
              ml={{ tablet: "45px" }}
              src={`${sl.config.jewlr_asset_url}images/info/warranty/${item.icon}.png`}
              width={{ _: "75px", tablet: "85px" }}
            />
          </Box>
          <Box
            flex="0 0 auto"
            px={3}
            textAlign={{ _: "center", tablet: "left" }}
            width={{ tablet: "100%" }}
          >
            <Typography fontWeight="700" pb={1} pt={{ _: "4px", tablet: 0 }}>
              {item.title}
            </Typography>

            <Typography px={{ _: 3, tablet: 0 }} width={{ tablet: "70%" }}>
              {item.text}
            </Typography>
          </Box>
        </Box>
      ))}
    </Flex>
    <Divider
      color="grey.20"
      height="1px"
      mb={{ _: 6, tablet: 8 }}
      mt={{ tablet: 8 }}
      width={{ _: "85%", tablet: "50%" }}
    />
  </Box>
)

export default WhatsCovered
